export const migrateFeedToManualApi = async (
    feedName: any,
    mail: any,
    newmail: any,
    token: string,
    propertyIds: string,
    status: string
) => {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    myHeaders.append('Authorization', `Bearer ${token}`);
    const formdataenmin = new URLSearchParams();
    formdataenmin.set('email', mail)
    formdataenmin.set('reason', 'manual')
    formdataenmin.set('newemail', newmail)
    formdataenmin.set('feedkey', feedName)
    formdataenmin.set('property_ids', propertyIds)
    formdataenmin.set('status', status)

    const requestOptions = {
        method: 'POST',
        body: formdataenmin,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = process.env.REACT_APP_MIGRATE_FEED;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

